// react and js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// mui

// components

// hooks

// layouts

// pages

// theme

// utils
import {
  DEFAULT_LANGUAGE,
  SUPPORTED_CODES,
  detectLanguageFromPath,
} from "./languages";

import en from "./locales/en/common.json";
import de from "./locales/de/common.json";
import fr from "./locales/fr/common.json";
import es from "./locales/es/common.json";
import zhCN from "./locales/zh-CN/common.json";
import zhTW from "./locales/zh-TW/common.json";
import ja from "./locales/ja/common.json";
import ptBR from "./locales/pt-BR/common.json";
import ar from "./locales/ar/common.json";
import ko from "./locales/ko/common.json";
import pl from "./locales/pl/common.json";

// widgets

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------
const resources = {
  en: { common: en },
  de: { common: de },
  fr: { common: fr },
  es: { common: es },
  "zh-CN": { common: zhCN },
  "zh-TW": { common: zhTW },
  ja: { common: ja },
  "pt-BR": { common: ptBR },
  ar: { common: ar },
  ko: { common: ko },
  pl: { common: pl },
};

const initialLanguage =
  typeof window !== "undefined"
    ? detectLanguageFromPath(window.location.pathname).code
    : DEFAULT_LANGUAGE;

i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage,
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: SUPPORTED_CODES,
  defaultNS: "common",
  ns: ["common"],
  interpolation: { escapeValue: false },
  returnEmptyString: false,
  react: { useSuspense: false },
});

// ----------------------------------------------------------------------
// Properties
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
export default i18n;
